import styled from 'styled-components'

export const AvatarWrapper = styled.img `
    border-radius:6px;
    object-fit: cover;
    overflow: hidden;
    object-position: top;

`
